import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SeguridadService } from '../services/seguridad.service';
import { BaseModel } from './base.model';

const seguridad = new SeguridadService();

export class TransaccionModel extends BaseModel {

    private _nroTransaccion:               number;
    private _fechaTransaccion:             Date;
    private _aprobado:                     boolean;
    private _anulado:                      boolean;
    private _idAnuladoPor:                 number;
    private _codAnuladoPor:                string;
    private _fechaAnulacion:               Date;
    
    constructor() {
        super();
        this._anulado = false;
        this._aprobado = false;
        this._fechaTransaccion = new Date();
    }

    public set nroTransaccion( nroTransaccion: number ) {
        this._nroTransaccion = nroTransaccion;
    }
    public get nroTransaccion() {
        return this._nroTransaccion;
    }

    public set fechaTransaccion( fechaTransaccion: Date ) {
        this._fechaTransaccion = fechaTransaccion;
    }
    public get fechaTransaccion(): Date {
        return this._fechaTransaccion;
    }

    public set aprobado( aprobado: boolean ) {
        this._aprobado = aprobado;
    }
    public get aprobado() {
        return this._aprobado;
    }

    public set anulado( anulado: boolean ) {
        this._anulado = anulado;
    }
    public get anulado() {
        return this._anulado;
    }

    public set idAnuladoPor( idAnuladoPor: number ) {
        this._idAnuladoPor = idAnuladoPor;
    }
    public get idAnuladoPor() {
        return this._idAnuladoPor;
    }

    public set codAnuladoPor( codAnuladoPor: string ) {
        this._codAnuladoPor = codAnuladoPor;
    }
    public get codAnuladoPor() {
        return this._codAnuladoPor;
    }

    public set fechaAnulacion( fechaAnulacion: Date ) {
        this._fechaAnulacion = fechaAnulacion;
    }
    public get fechaAnulacion(): Date {
        return this._fechaAnulacion;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        this._nroTransaccion = objeto.nro_transaccion;
        this._fechaTransaccion = objeto.fecha_transaccion ? new Date(objeto.fecha_transaccion): objeto.fecha_transaccion;
        this._aprobado = objeto.aprobado;
        this._anulado = objeto.anulado;
        this._idAnuladoPor = objeto.id_anulado_por;
        this._codAnuladoPor = objeto.inactivado_por?.codigo;
        this._fechaAnulacion = objeto.fecha_anulacion ? new Date(objeto.fecha_anulacion): objeto.fecha_anulacion;
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("nro_transaccion", new FormControl(this._nroTransaccion));
        fg.addControl("fecha_transaccion", new FormControl(this._fechaTransaccion, Validators.required));
        fg.addControl("aprobado", new FormControl(this._aprobado));
        fg.addControl("anulado", new FormControl(this._anulado));
        fg.addControl("id_anulado_por", new FormControl(this._idAnuladoPor));
        fg.addControl("cod_anulado_por", new FormControl(this._codAnuladoPor));
        fg.addControl("fecha_anulacion", new FormControl(this._fechaAnulacion));
        return fg;
    }

    async actualizarDatos( objeto: Record<string, any> ) {
        await super.actualizarDatos( objeto );
        this._fechaTransaccion = objeto.fecha_transaccion;
        this._aprobado = objeto.aprobado;
        this._anulado = objeto.anulado;
        this._idAnuladoPor = objeto.id_anulado_por;
        this._fechaAnulacion = objeto.fecha_anulacion;
    }

}
